export default __webpack_public_path__ + "static/media/try-arrow-desktop.e69c4b6d.svg";